import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImportFileOutputData } from '#/graphql/types';
import SuccessModalBase from '../base/SuccessModalBase';

interface SuccessModalProps {
  visible: boolean;
  onHiding: () => void;
  importResult: ImportFileOutputData | null;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ visible, onHiding, importResult }) => {
  const navigate = useNavigate();

  const redirectToAssetList = useCallback(() => {
    onHiding();
    navigate('/assets/list');
  }, [onHiding, navigate]);

  return (
    <SuccessModalBase
      visible={visible}
      onHiding={onHiding}
      importResult={importResult}
      entityRecordsLabelLower="asset records"
      entityPluralLabelLower="assets"
      onRedirect={redirectToAssetList}
    />
  );
};

export default SuccessModal;
